import { FornecedorSimplificadoForm } from "../../../../../common/presentation/schemas/FornecedorSimplificado";
import { IComprasService } from "../../../data/services/compras_service";
import { ICreateFornecedorSimplificadoUseCase } from "../../../presentation/useCases/create/create_fornecedor_simplificado_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateFornecedorSimplificadoUseCase
 */

export class CreateFornecedorSimplificadoUseCase implements ICreateFornecedorSimplificadoUseCase {
  constructor(private readonly repository: IComprasRepository) {

  }

  async createFornecedorSimplificado(form: FornecedorSimplificadoForm): Promise<number> {
    return await this.repository.createFornecedorSimplificado(form);

  }
}
